import { IC_STANDBY_OFF, IC_ANDROID, IC_IOS, IC_VIDEO } from "../../../assets"
import { SelectorTypes } from "../components/Selector/Selector.types"

type Links = {
  linkAppGooglePlay: string
  linkAppAppleStore: string
  linkVideoYouTube: string
  linkCecotecSupport: string
}

export function getLinks(links: Links): SelectorTypes.Props[] {
  return [
    {
      title: "Android",
      text: "Descargar App",
      icon: IC_ANDROID,
      link: links.linkAppGooglePlay,
    },
    {
      title: "iOS",
      text: "Descargar App",
      icon: IC_IOS,
      link: links.linkAppAppleStore,
    },
    {
      title: "Vincula paso a paso",
      text: "Ver video",
      icon: IC_VIDEO,
      link: links.linkVideoYouTube,
    },
    {
      title: "Soporte CecoCare",
      text: "Un link, todas las soluciones",
      icon: IC_STANDBY_OFF,
      link: links.linkCecotecSupport,
    },
  ]
}
